import React from 'react'
import { safeLocalFormat } from '../../../utilities/functions'

const CheckInDate = ({row}) => {
  return <div>{row.checkInDate ? safeLocalFormat(row.checkInDate) : ""}</div>;
}

export default CheckInDate
